// Shows the next slide in a separate iframe. This iframe loads the deck WITHOUT
// a session parameter so its sync-plugin stays dormant. We programmatically
// drive it to (h, v, f) one step ahead of the speaker iframe whenever the
// speaker advances.

const SLIDE_W = 1920;
const SLIDE_H = 1080;

function fit(host, iframe) {
  const r = host.getBoundingClientRect();
  const scale = Math.min(r.width / SLIDE_W, r.height / SLIDE_H);
  iframe.style.transform = `scale(${scale})`;
  iframe.style.left = ((r.width  - SLIDE_W * scale) / 2) + 'px';
  iframe.style.top  = ((r.height - SLIDE_H * scale) / 2) + 'px';
}

function nextIndices(reveal, indices) {
  const { h, v, f } = indices;
  const cur = reveal.getSlide(h, v);
  const totalF = cur ? cur.querySelectorAll('.fragment').length : 0;
  if (f + 1 < totalF) return { h, v, f: f + 1 };
  if (reveal.getSlide(h, v + 1)) return { h, v: v + 1, f: -1 };
  if (reveal.getSlide(h + 1, 0)) return { h: h + 1, v: 0, f: -1 };
  return null;
}

export default {
  id:   'next-slide',
  slot: 'next-slide',
  mount({ slot, deck, deckId }) {
    slot.innerHTML = `
      <div class="panel-header"><span>Next</span></div>
      <div class="panel-body"><div class="slide-frame-host"><iframe data-role="frame"></iframe></div></div>
    `;
    const host  = slot.querySelector('.slide-frame-host');
    const frame = slot.querySelector('iframe');
    frame.src = `/decks/${encodeURIComponent(deckId)}/`;

    let previewReveal = null;
    frame.addEventListener('load', () => {
      const tryReady = () => {
        const w = frame.contentWindow;
        if (w?.Reveal?.isReady?.()) {
          previewReveal = w.Reveal;
          fit(host, frame);
          syncToNext();
        } else setTimeout(tryReady, 100);
      };
      tryReady();
    });

    const syncToNext = () => {
      if (!previewReveal || !deck.ready) return;
      const next = nextIndices(deck.reveal, deck.getIndices());
      if (!next) return;
      previewReveal.slide(next.h, next.v, next.f);
    };

    deck.onReady(() => {
      deck.reveal.on('slidechanged',   syncToNext);
      deck.reveal.on('fragmentshown',  syncToNext);
      deck.reveal.on('fragmenthidden', syncToNext);
    });

    new ResizeObserver(() => fit(host, frame)).observe(host);
  },
};
